import { Outlet } from 'react-router'
import { getCookie } from '@/shared/lib/cookies'
import { LayoutProvider } from '@/context/layout-provider'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ThemeSwitch } from '@/components/theme-switch'
import { V2Breadcrumbs } from './V2Breadcrumbs'
import { V2Sidebar } from './V2Sidebar'

function V2HeaderBar() {
  return (
    <Header fixed className="border-b bg-background">
      <V2Breadcrumbs />
      <div className="ms-auto flex shrink-0 items-center">
        <ThemeSwitch />
      </div>
    </Header>
  )
}

export function V2AuthenticatedLayout() {
  const defaultOpen = getCookie('sidebar_state') !== 'false'

  return (
    <LayoutProvider>
      <SidebarProvider defaultOpen={defaultOpen}>
        <V2Sidebar />
        <SidebarInset className="@container/content flex flex-col">
          <V2HeaderBar />
          <Main id="content" className="flex-1 p-4 sm:p-6">
            <Outlet />
          </Main>
        </SidebarInset>
      </SidebarProvider>
    </LayoutProvider>
  )
}
